(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  (function() {
    const headerWrapper = document.querySelector('.header-wrapper');
    const menuToggle = document.querySelector('.header__menu-toggle');
    const backdrop = document.querySelector('.header__backdrop');
    
    if (!menuToggle || !headerWrapper) return;
    
    // Toggle menu open/close
    menuToggle.addEventListener('click', function() {
      const isOpen = headerWrapper.classList.contains('is-open');
      
      if (isOpen) {
        closeMenu();
      } else {
        openMenu();
      }
    });
    
    // Close menu when clicking backdrop
    backdrop.addEventListener('click', function() {
      closeMenu();
    });
    
    // Close menu on escape key
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && headerWrapper.classList.contains('is-open')) {
        closeMenu();
        menuToggle.focus();
      }
    });
    
    function openMenu() {
      headerWrapper.classList.add('is-open');
      document.body.classList.add('menu-open');
      menuToggle.setAttribute('aria-expanded', 'true');
      backdrop.setAttribute('aria-hidden', 'false');
    }
    
    function closeMenu() {
      headerWrapper.classList.remove('is-open');
      document.body.classList.remove('menu-open');
      menuToggle.setAttribute('aria-expanded', 'false');
      backdrop.setAttribute('aria-hidden', 'true');
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["similar-products"] && !Shopify.designMode) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('.similar-products');

            if (recommendations && recommendations.innerHTML.trim().length) {
              // Replace the entire web component with the fetched content
              this.outerHTML = recommendations.outerHTML;
            }
          })
          .catch(e => {
            console.error('Failed to load recommendations:', e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  if (!customElements.get('product-recommendations')) {
    customElements.define('product-recommendations', ProductRecommendations);
  }

  } catch(e) { console.error(e); }
})();
})();
